module.exports = __webpack_public_path__ + "img/bussiness-item-1.12602565.png";